<template>
  <div class="stepItemList">
    <div class="stepItem">
      <div class="stepWait center" v-if="stepNum <= 1">
        <i class="el-icon-more waitIcon"></i>
      </div>
      <div class="stepFinish center" v-if="stepNum > 1">
        <i class="el-icon-check finishIcon"></i>
      </div>
      <div class="stepLabel" :class="{ active: stepNum >= 1 }">
        选择账号类型
      </div>
    </div>
    <div class="stepItem">
      <div class="stepNum" v-if="stepNum < 2">2</div>
      <div class="stepWait center" v-if="stepNum === 2">
        <i class="el-icon-more waitIcon"></i>
      </div>
      <div class="stepFinish center" v-if="stepNum > 2">
        <i class="el-icon-check finishIcon"></i>
      </div>
      <div class="stepLabel" :class="{ active: stepNum >= 2 }">
        填写账号信息
      </div>
    </div>
    <div class="stepItem">
      <div class="stepNum" v-if="stepNum < 3">3</div>
      <div class="stepFinish center" v-if="stepNum >= 3">
        <i class="el-icon-check finishIcon"></i>
      </div>
      <div class="stepLabel" :class="{ active: stepNum >= 3 }">注册完成</div>
    </div>
    <div class="setpLineBg"></div>
    <div class="setpLine" :style="{ width: stepObj.lineLong + 'px' }"></div>
  </div>
</template>

<script>
export default {
  props: {
    stepNum: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    stepObj() {
      switch (this.stepNum) {
        case 1:
          return {
            lineLong: 160,
          };
        case 2:
          return {
            lineLong: 380,
          };
        case 3:
          return {
            lineLong: 556,
          };
        default:
          return {
            lineLong: 160,
          };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stepItemList {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: relative;
}
.stepItem {
  z-index: 10;
  position: relative;
}
.stepWait {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(315deg, #2a54d1 0%, #5b85ff 100%);
  box-sizing: border-box;
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 1px 4px 0px rgba(42, 84, 209, 0.5);
}
.stepFinish {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background: linear-gradient(315deg, #00ce72 0%, #29e28f 100%);
  box-sizing: border-box;
  border: 2px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0px 1px 4px 0px rgba(41, 226, 143, 0.5);
}

.waitIcon,
.finishIcon {
  font-size: 16px;
  color: #ffffff;
  font-weight: bold;
}
.stepNum {
  width: 32px;
  height: 32px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  border: 2px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0px 1px 4px 0px rgba(153, 153, 153, 0.5);
  font-family: AlibabaPuHuiTi;
  font-size: 16px;
  line-height: 28px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
}
.stepLabel {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #666;
  position: absolute;
  width: 100px;
  left: -34px;
  top: 34px;
}
.stepLabel.active {
  color: #333;
}

.setpLineBg {
  position: absolute;
  width: 556px;
  height: 2px;
  border-radius: 7px;
  opacity: 0.1;
  background: linear-gradient(270deg, #2a54d1 0%, #5b85ff 100%);
}
.setpLine {
  position: absolute;
  left: 29px;
  width: 160px;
  height: 4px;
  border-radius: 7px;
  opacity: 1;
  background: linear-gradient(271deg, #2a54d1 0%, #5b85ff 100%);
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
